import joinIntroLayout from "@/views/Join/Intro/index.vue";
import joinManager from "@/views/Join/Manager/index.vue";
import joinMember from "@/views/Join/Member/index.vue";
import joinComplete from "@/views/Join/Complete/index.vue";

export default [
  {
    path: "intro",
    name: "JoinIntro",
    component: joinIntroLayout,
  },
  {
    path: "manager",
    component: joinManager,
  },
  {
    path: "member",
    component: joinMember,
  },
  {
    path: "complete",
    component: joinComplete,
  },
];
